import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { User } from '@/types/user'

export const useAuthStore = defineStore('auth', () => {
  // 状态
  const user = ref<User | null>(null)
  const isLoading = ref(false)

  // 计算属性
  const isAuthenticated = computed(() => !!user.value)
  const userRoles = computed(() => user.value?.roles || [])

  // 操作
  const loginWithGoogle = async () => {
    try {
      isLoading.value = true
      
      // 模拟Google登录
      await new Promise(resolve => setTimeout(resolve, 1500))
      
      // 模拟用户数据
      user.value = {
        id: '1',
        name: '猫咪爱好者',
        email: 'cat.lover@example.com',
        avatar: 'https://images.unsplash.com/photo-1494790108755-2616c1a8e0ec?w=150',
        roles: ['user'],
        joinDate: new Date('2024-01-15'),
        postsCount: 12,
        consultationsCount: 5
      }
      
      return { success: true }
    } catch (error: any) {
      return { 
        success: false, 
        message: '登录失败，请稍后重试' 
      }
    } finally {
      isLoading.value = false
    }
  }

  const logout = () => {
    user.value = null
  }

  const updateProfile = async (profileData: Partial<User>) => {
    try {
      isLoading.value = true
      
      // 模拟API调用
      await new Promise(resolve => setTimeout(resolve, 1000))
      
      user.value = { ...user.value, ...profileData } as User
      return { success: true }
    } catch (error: any) {
      return { 
        success: false, 
        message: '更新失败，请稍后重试' 
      }
    } finally {
      isLoading.value = false
    }
  }

  // 权限检查
  const hasRole = (role: string) => {
    return userRoles.value.includes(role)
  }

  const hasAnyRole = (roles: string[]) => {
    return roles.some(role => userRoles.value.includes(role))
  }

  return {
    // 状态
    user,
    isLoading,
    // 计算属性
    isAuthenticated,
    userRoles,
    // 操作
    loginWithGoogle,
    logout,
    updateProfile,
    hasRole,
    hasAnyRole
  }
})
    